import React from 'react';
import { Navigate } from 'react-router-dom';

function HomeRedirect() {
    return <Navigate to="/dashboard" replace />;
}

export default HomeRedirect;
